var map = {
	"./alpamare.png": 2862,
	"./bcge.png": 3488,
	"./buhler.png": 6031,
	"./clienia.png": 3020,
	"./confiseur_laderach_ag.png": 1107,
	"./csl_behring.png": 9149,
	"./ems_chemie.png": 2924,
	"./grand_resort_bad_ragaz.png": 7721,
	"./griesser.png": 9631,
	"./helvetia.png": 3815,
	"./herisau_psychiatrie.png": 6548,
	"./hilti.png": 6579,
	"./hitachi_baden.png": 4354,
	"./hitachi_zurich.png": 65,
	"./hotelplan_suisse.png": 311,
	"./huber_suhner.png": 4229,
	"./kantonsspital-right.png": 4173,
	"./kantonsspital.png": 788,
	"./leica.png": 6587,
	"./logistic_zentrum.png": 5185,
	"./lonza.png": 3277,
	"./metrohm.png": 3223,
	"./mobiliar.png": 9374,
	"./omega.png": 1564,
	"./post-finance.png": 5890,
	"./post_finance.png": 4548,
	"./post_verteilzentrum.png": 6492,
	"./rolex.png": 3149,
	"./spital_grabs.png": 5316,
	"./spital_herisau.png": 5738,
	"./spital_musnterlingen.png": 1170,
	"./stadler_bussnang.png": 2564,
	"./sunrise.png": 4812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9125;